const mainSearchForm = {
  flights: "टिकट", // translated 
  tours: "टूर्स", // translated 
  hotel: "होटल", // translated 
  hotels: "होटल", // translated 
  services: "सेवाएं", // translated 
  search: "खोज", // translated 
  destination: "गंतव्य", // translated 
  includedServices: "शामिल सेवाएं", // translated 
  packageDuration: "पैकेज की अवधि", // translated 
  checkInOut: "चेक इन / चेक आउट", // translated 
  guests: "अतिथियों", // translated 
  adults: "वयस्कों", // translated 
  children: "बच्चे", // translated 
  child: "बच्चा", // translated 
  age: "आयु", // translated 
  yearsOld: "वर्षों पुराना", // translated 
  rooms: "कमरा", // translated 
  close: "बंद करना", // translated 
  searchType: "तलाश की विधि", // translated 
  accommodation: "आवास", // translated 
  transfers: "स्थानांतरण", // translated 
  toursExperiences: "यात्राएँ/अनुभव", // translated 
  nights: "नाइट्स", // translated 
  days: "दिन", // translated 
  packageType: "पैकेज प्रकार", // translated 
  tourType: "यात्रा का प्रकार", // translated 
  packages: "संकुल", // translated 
  cars: "कारें", // translated 
  cruises: "परिभ्रमण", // translated 
  infantsInSeat: "सीट में शिशु", // translated 
  infantsOnLap: "गोद में शिशु", // translated 
  airport: "एयरपोर्ट", // translated 
  passengers: "यात्रियों", // translated 
  departureReturn: "प्रस्थान और वापसी की तिथियां", // translated 
  origin: "मूल", // translated 
  roundTrip: "राउंड ट्रिप", // translated 
  isRoundTrip: "यह राउंड ट्रिप है", // translated 
  dream_packages: "ड्रीम पैकेज", // translated 
  partying: "पार्टी", // translated 
  thingsToDo: "करने के लिए काम", // translated 
};


export default mainSearchForm;
